import pegasus from "../../build/global/js/00-pegasus";

window.navigation = (website) => {
    return {
        open: false,
        scrolled: false,
        visible: true,
        mobMenuOpen: false,
        sub_nav: [],
        lastScrollTop: 0,
        currentMenuOpen: '',
        ipBarVisible: false,
        megamenu: null,

        toggleOpen(menuID){
            this.sub_nav = [];
            if(this.open !== menuID){
                this.open = menuID;
            } else {
                this.open = null;
            }
        },
        toggleMenu(subNavId) {
            let i = this.sub_nav.indexOf(subNavId);
            if (i === -1) {
                this.sub_nav.push(subNavId);
            } else {
                this.sub_nav.splice(i,1);
            }
        },
        toggleSubMenu(subNavId) {
            return this.sub_nav.includes(subNavId);
        },
        lockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = 'hidden';
        },
        unlockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = 'auto';
        },
        menuScrolling(hideOnScroll = false){

            const navigationContainer = document.getElementById('page-nav-container'),
                navigationHeight = navigationContainer.offsetHeight;

            this.scrolled = window.scrollY >= 10;

            if(hideOnScroll) {
                let st = window.scrollY;

                if (st >= this.lastScrollTop) {
                    //Scroll Down
                    if(st >= navigationHeight){
                        navigationContainer.classList.add("-translate-y-full");
                        this.visible = false;
                    } else {
                        navigationContainer.classList.remove("-translate-y-full");
                        this.visible = true;
                    }
                } else {
                    //Scroll Up
                    navigationContainer.classList.remove("-translate-y-full");
                    this.visible = true;
                }

                this.lastScrollTop = st;
            }

        },
    }
}
